import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

// Create priority API
const priorityAPI = createApi({
      reducerPath:"priorityAPI",
      baseQuery:customFetchBase,
      endpoints:(builder)=>({
      // Priority Endpoints
  
      // Query to get all Priority
      getAllPriorityList: builder.query({
        query: () => ({
            url: `/Priority/GetAllPriorityList`,
            method: 'GET',
        }),
        transformResponse: transformSuccessResponse,
        transformErrorResponse: transformErrorResponse,
        }),
    }),
})

// Extract hooks for easy access to various API requests 
export const {
    useLazyGetAllPriorityListQuery
  } =priorityAPI;
  
  export default priorityAPI;